import { useState, useEffect } from 'react';

export default function useLoader(){
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        setShowLoader(false);

        return function() {
            setShowLoader(true);
        };
    }, []);

    return showLoader;
}
